import { trackGenericAction } from "../../../shared/analytics/dataLayer";
import { getCustomContextMetadata, trackConvivaCustomEvent } from "../../../shared/analytics/media";
import telusConvivaAnalytics from "../../../shared/utils/convivaAnalytics";
import { ANALYTICS_EVENT_TYPES, ACTION_VALUES, WEB_ACTION_EVENT_NAMES } from "../../../shared/constants/analytics";
import errorConstants from "../../../shared/constants/error";
import { PIN_MODAL_MODES, PIN_MODAL_TYPES } from "../../../components/PinModal";
import { getGenericErrorEventHandler } from "../../../shared/analytics/helpers";
import PlayerConstants from "../../../shared/constants/player";

const {
  PLAYER_CONTROLS: { RESUME },
} = PlayerConstants;
const { AVS_ERROR_CODES } = errorConstants;

export const createPinModal = (
  currentContentId,
  assetId,
  getHeartBeatEntitlements,
  getMediaNodeMetaData,
  isConvivaAppTrackerEnabled,
  userProfile,
  appProvider,
  isInHome,
  setPlayerControlState,
  setShowContentLockedOverlay,
  pcPin,
  restartPcPinTimer,
  setIsPinLocked,
  translate,
  isDynatraceTrackingEnabled
) => {
  return {
    title: translate("enter_parental_pin"),
    isCloseable: true,
    pinModalMode: PIN_MODAL_MODES.ACCESS,
    pinModalType: PIN_MODAL_TYPES.PARENTAL,
    pinConfirmHandler: (pin) => {
      return getHeartBeatEntitlements(currentContentId, assetId, pin)
        .then(() => {
          // Resume playback now that content is no longer blocked
          trackGenericAction(
            ANALYTICS_EVENT_TYPES.PARENTAL_PIN_CONTENT_UNLOCK,
            getMediaNodeMetaData(),
            isDynatraceTrackingEnabled
          );
          if (isConvivaAppTrackerEnabled) {
            trackConvivaCustomEvent(
              ANALYTICS_EVENT_TYPES.PARENTAL_PIN_CONTENT_UNLOCK,
              getCustomContextMetadata(getMediaNodeMetaData(), userProfile, appProvider, isInHome)
            );
          }
          setPlayerControlState(RESUME);
          setShowContentLockedOverlay(false);
          pcPin.current = pin;
          restartPcPinTimer();
        })
        .catch((e) => {
          if (
            e?.code?.includes(AVS_ERROR_CODES.MAX_ATTEMPTS_INCORRECT_PARENTAL_PIN) ||
            (AVS_ERROR_CODES.INCORRECT_PIN_CODES.includes(e?.code) && e.params?.remainingAttempts === 0)
          ) {
            setIsPinLocked(true);
          } else {
            throw e;
          }
        });
    },
    pinAnalyticsErrorEventHandler: getGenericErrorEventHandler(
      ANALYTICS_EVENT_TYPES.PARENTAL_PIN_CONTENT_UNLOCK_ERROR,
      ACTION_VALUES.PARENTAL_PIN_CONTENT_UNLOCK,
      WEB_ACTION_EVENT_NAMES.PARENTAL_PIN_CONTENT_UNLOCK_ERROR,
      isDynatraceTrackingEnabled
    ),
  };
};

export const reportParentalPinStart = (assetId, contentType) => {
  telusConvivaAnalytics.reportParentalPinStart(assetId, contentType);
};
